import { render, staticRenderFns } from "./TrainingCampItem.vue?vue&type=template&id=1104bb44&scoped=true&"
import script from "@/scripts/TrainingCamp/TrainingCamps/components/TrainingCampItem.js?vue&type=script&lang=js&"
export * from "@/scripts/TrainingCamp/TrainingCamps/components/TrainingCampItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1104bb44",
  null
  
)

export default component.exports